import React from "react";
import PdfBase from "./PdfBase";
import { generateInterestExpensePdf } from "./generator";
import ExcelBase from "../Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  interestExpenseRows,
  assetsRows,
  totalInterestExpenses,
  totalAssets,
  totalNonIncomeAssets,
  disAllowableInterest,
  notes,
  reviewNotes,
}) => {
  const sharedArgs = [
    schedule,
    company,
    interestExpenseRows,
    assetsRows,
    totalInterestExpenses,
    totalAssets,
    totalNonIncomeAssets,
    disAllowableInterest,
    notes,
    reviewNotes,
  ];
  return (
    <>
      <PdfBase
        company={company}
        enableDraftView
        generatePdf={(forView) =>
          generateInterestExpensePdf(forView, ...sharedArgs)
        }
        downloadName='Interest Expense Schedule'
      />
      <ExcelBase
        generateExcel={(forView) =>
          generateInterestExpensePdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PdfGenerator;
